export default __webpack_public_path__ + "static/media/profileGray.fa40b04a.svg";